export default __webpack_public_path__ + "static/media/controle-reception.5b3afe4b.svg";